import React from "react";
import { cn } from "@/lib/utils";

/**
 * Container — max-w-7xl with responsive horizontal padding.
 * Use everywhere for consistent horizontal rhythm.
 */
export const Container = React.forwardRef(function Container(
  { as: Tag = "div", className, children, ...props },
  ref,
) {
  return (
    <Tag
      ref={ref}
      className={cn(
        "mx-auto w-full max-w-7xl px-6 sm:px-8 lg:px-12",
        className,
      )}
      {...props}
    >
      {children}
    </Tag>
  );
});

export default Container;
